import { useSearchParams } from 'react-router';

/**
 * A page's tab kept in `?tab=` (the first tab leaves it out). Each switch is its own history entry,
 * so the Back button returns to the tab you came from.
 */
export function useTabParam<T extends string>(tabs: readonly [T, ...T[]]): [T, (t: T) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const current = tabs.find((t) => t === raw) ?? tabs[0];
  const set = (t: T) =>
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      if (t === tabs[0]) next.delete('tab');
      else next.set('tab', t);
      return next;
    });
  return [current, set];
}
